import { wceApi } from '@/api';
import { stringify } from 'qs';

type ImageItem = {
  id: number;
  imageUrl: string;
  height: number;
  thumbnail: string;
  width: number;
};

export let imagesCache: ImageItem[] = [];

export const getImageUrl = (id: number) => {
  const index = imagesCache.findIndex((item) => item.id == id);

  return index >= 0 ? imagesCache[index].imageUrl : ''
};

type PostDesignImagesResponse = ImageItem[];

export const uploadImages = (
  imgFiles: File[],
  cb: (images: ImageItem[]) => void
) => {
  Promise.all(
    imgFiles.map(async (imgFile) => {
      const formData = new FormData();
      formData.append('file', imgFile);

      return (
        await wceApi.post<PostDesignImagesResponse>('/design/images', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
      ).data;
    })
  )
    .then((imageItems) => {
      const images = imageItems.flat();

      imagesCache.push(...images);

      cb(imageItems.flat());
    })
    .catch((err) => {
      console.error(err);
    });
};

type GetDesignImagesResponse = ImageItem[];

export const fetchImageList = (
  cb: (images: ImageItem[]) => void
) => {
  wceApi.get<GetDesignImagesResponse>('/design/images')
    .then(({ data }) => {
      imagesCache = data;

      cb(data);
    });
};

export const getImageFilename = (id: number) => {
  const image = imagesCache.find((item) => item.id === id);

  return image?.imageUrl.replace(/.+\//, '');
};

export const deleteImage = (
  imageNo: number,
  cb: () => void
) => {
  wceApi.delete<void>(`/design/images/${imageNo}`)
    .then(() => {
      const idx = imagesCache.findIndex((item) => item.id === imageNo);
      imagesCache.splice(idx, 1);
      cb();
    });
};

export const deleteImages = (
  ids: string,
  cb: () => void
) => {
  const imageNos = ids.split(',').map(Number);

  wceApi.delete<void>(`/design/images${
    stringify({ imageNos }, {
      addQueryPrefix: true,
      arrayFormat: 'comma',
    })
  }`)
    .then(() => {
      imagesCache = imagesCache.filter(({ id }) => !imageNos.includes(id));
      cb();
    });
};
